
<template>
  <div>
    <div class="text-center">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <h2 class="text-primary">Location Setup</h2>
          <p class="text-muted font-size-14 mb-2">
            Please enter location details to configure ATMS
          </p>
        </div>
      </div>
      <hr />
    </div>
    <div class="row">
      <div class="col-12">
        <form @submit.prevent="saveLocationDetails">
          <div class="row">
            <div class="col-12">
              <div class="mb-2">
                <label>Location Name</label>
                <input
                  placeholder="Enter Location Name"
                  type="text"
                  class="form-control inp-bg"
                  v-model="locationDetails.locationName"
                  required
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-2">
                <label>Location Description</label>
                <textarea
                  placeholder="Location Description"
                  v-model="locationDetails.description"
                  class="form-control inp-bg"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Stretch Distance in KMS</label>
                <input
                  placeholder="Stretch Distance in KMS"
                  type="number"
                  min="1"
                  max="1000"
                  class="form-control inp-bg"
                  v-model="locationDetails.distance"
                  required
                />
              </div>
            </div>
            <div class="col-3">
              <div class="mb-2">
                <label>Start CH</label>
                <input
                  placeholder="Ex: 0+0"
                  type="text"
                  class="form-control inp-bg"
                  v-model="locationDetails.startChainage"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="mb-2">
                <label>End CH</label>
                <input
                  placeholder="Ex: 200+0"
                  type="text"
                  class="form-control inp-bg"
                  v-model="locationDetails.endChainage"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Enter Start Latitude</label>
                <input
                  placeholder="Enter Start Latitude"
                  class="form-control inp-bg"
                  v-model="locationDetails.startLatitude"
                  required
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Enter Start Longitude</label>
                <input
                  placeholder="Enter Start Longitude"
                  class="form-control inp-bg"
                  v-model="locationDetails.startLongitude"
                  required
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Enter Center Latitude</label>
                <input
                  placeholder="Enter Center Latitude"
                  class="form-control inp-bg"
                  v-model="locationDetails.centerLatitude"
                  required
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Enter Center Longitude</label>
                <input
                  placeholder="Enter Center Longitude"
                  class="form-control inp-bg"
                  v-model="locationDetails.centerLongitude"
                  required
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Enter End Latitude</label>
                <input
                  placeholder="Enter End Latitude"
                  class="form-control inp-bg"
                  v-model="locationDetails.endLatitude"
                  required
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label>Enter End Longitude</label>
                <input
                  placeholder="Enter End Longitude"
                  class="form-control inp-bg"
                  v-model="locationDetails.endLongitude"
                  required
                />
              </div>
            </div>
          </div>

          <hr />

          <!-- BUTTON -->
          <div class="row">
            <div class="col-12">
              <div class="mt-2 text-center">
                <button
                  :disabled="loading"
                  type="submit"
                  class="btn btn-primary me-1 w-50"
                >
                  Save Location <i class="bx bx-rocket ml-2"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import adminMixin from "@/mixins/administration";

export default {
  props: {
    options: Array,
  },
  mixins: [adminMixin],
  data() {
    return {
      locationDetails: {},
    };
  },
  computed: {
    loading() {
      return this.$store.state.layout.loader;
    },
  },
  mounted() {
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
  methods: {
    async saveLocationDetails() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        const location = await this.SaveLocationDetails(this.locationDetails);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Saved!", "Location Configured", "success").then(() => {
          this.$emit("loadLocation", {
            id: location.id,
            name: location.location_name,
          });
        });
      } catch (e) {
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to configure location details", "error");
      }
    },
  },
};
</script>
